import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('breeze-engine-lib', {
  library: 'breeze-engine-lib'
});